// extracted by mini-css-extract-plugin
module.exports = {"superior":"superior___1uUah","copyright":"copyright___3pilA","brand":"brand___37ipW"};